import moment from "moment";

export const capitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);
export const DATE_FORMAT = "MM/DD/YYYY";

export const formatDate = (date: string) => moment(date).format(DATE_FORMAT);

export const roundNumber = (value: number) => Math.round(value * 10) / 10;
